import { ProductConditionSummary, ConditionPrice } from '../../../../types';
import { PriceDisplay, PriceDisplayEnum } from 'src/areas/product/types';
import { IProductCondition } from './types';

export const getCondition = (
  condition: ProductConditionSummary,
  priceDisplay: PriceDisplay
) => {
  return {
    name: condition.name,
    from: getPriceByShipping(condition.priceRange.from, priceDisplay),
    to: getPriceByShipping(condition.priceRange.to, priceDisplay),
    count: condition.count,
  };
};

export const getConditions = (
  conditions: ProductConditionSummary[],
  priceDisplay: PriceDisplay
): IProductCondition[] => {
  const newTypes = getNewType(conditions);
  const usedTypes = getUsedTypes(conditions);
  const conditionList = [];

  if (newTypes) {
    conditionList.push(getCondition(newTypes, priceDisplay));
  }

  if (usedTypes) {
    conditionList.push(getCondition(usedTypes, priceDisplay));
  }

  return conditionList.length ? conditionList : [];
};

export function getNewType(types: ProductConditionSummary[]) {
  return types.find(e => e.name === 'new');
}

export function getUsedTypes(types: ProductConditionSummary[]) {
  return types.find(e => e.name === 'used');
}

export function getPriceByShipping(
  price: ConditionPrice,
  priceDisplay: PriceDisplay
) {
  const includeShipping =
    priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

  return includeShipping ? price.inclShipping! : price.exclShipping!;
}
